import initHelpers from "../components/initHelpers.js";

document.addEventListener("DOMContentLoaded", () => {

    // console.log("article-item.js")

    const { initCopyLink, makeTablesResponsive } = initHelpers();
    initCopyLink();
    makeTablesResponsive();

});
